/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MiscStats/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Location from './Location/index'
import React from 'react'
import TysiaProfileValueWithLabelText from 'DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/index'



/** @type {import('Simple/types.js').View} */
export default function MiscStats({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/MiscStats"
  
}) {
let leadUpdatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'lead',
path: 'updated_at',
format: fromFormat.dateISOToDateAndTime,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let leadTrackingMetadataIpValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'tracking_metadata.ip',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let leadTrackingMetadataBrowserInfoValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'tracking_metadata.browser_info',
})
  return (<React.Fragment
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 marginTop={0}
 isHorizontal={true}
 label="Last Seen"
 data="lead.updated_at"
 format="/Data/format.js dateISOToDateAndTime"
 value={leadUpdatedAtValueData}
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceS}
 marginBottom={dtSpaceS}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 size="small"
 marginTop={dtSpaceXxs}
 isHorizontal={true}
 label="Source IP"
 data="lead.tracking_metadata.ip"
 value={leadTrackingMetadataIpValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 size="small"
 marginTop={0}
 isHorizontal={true}
 label="User Agent"
 data="lead.tracking_metadata.browser_info"
 value={leadTrackingMetadataBrowserInfoValueData}
/>
{children}
</React.Fragment>)
}